import { getModule } from 'vuex-module-decorators';
import { FeaturesStore } from '@/features/features-store';
import { AuthStore } from '@/store/auth-store';
import { FeatureConstants } from '@/features/feature-constants';
import store from '@/store';

/**
 * Centralized utility for checking tab-related permissions.
 * This logic is used across multiple components to determine if layout tabs can be added.
 */
export class TabPermissions {
    private static featuresStore = getModule(FeaturesStore, store);
    private static authState = getModule(AuthStore, store);

    /**
     * Check if user can add layout tabs.
     * Requires both INCONTACT feature flag and enrollment team member status.
     */
    static canAddTabs(): boolean {
        return this.featuresStore.isFeatureEnabled(FeatureConstants.INCONTACT) && this.authState.isEnrollmentTeamMember;
    }
}
